import React from 'react';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import {
  Landing,
  Login,
  AdminBoard,
  StudentBoard,
  TeacherBoard, Lesson
} from "./pages";
import { Topic } from "./pages/Topic";

import { USER_ROLE_ENUM } from "./types";

function App() {
  const location = useLocation();
  const loggedUser = location.state?.user;

  return (
    <>
      <Routes>
        <Route path="*" element={<Navigate to="/" replace />}/>
        <Route path="/" element={<Landing/>}/>
        <Route path="/login/student" element={<Login userRole={USER_ROLE_ENUM.student}/>} />
        <Route path="/login/teacher" element={<Login userRole={USER_ROLE_ENUM.teacher}/>}/>
        <Route path="/login/admin" element={<Login userRole={USER_ROLE_ENUM.admin}/>}/>

        <Route path="/river-map" element={<StudentBoard user={loggedUser}/>}/>
        <Route path="/teacher-dashboard" element={<TeacherBoard/>}/>
        <Route path="/admin-dashboard" element={<AdminBoard/>}/>

        <Route path="/topic/:topicName" element={<Topic/>}/>
        <Route path="/topic/:topicName/:lessonType/*" element={<Lesson/>}/>

        {/*<Route path={`/topic/land-nature/learn/${LEARN_ACTIVITIES[0].id}`} element={<Activity type="learn"/>}/>*/}


        {/*<Route path="/topic/land-nature/words" element={<Landing/>}/>*/}
        {/*<Route path="/topic/land-nature/practice" element={<Landing/>}/>*/}
        {/*<Route path="/topic/helping-sharing/words" element={<Landing/>}/>*/}
        {/*<Route path="/topic/helping-sharing/practice" element={<Landing/>}/>*/}
      </Routes>
    </>
  );
}

export default App;
